import React from 'react';

interface SplitEmailsStepProps {
  splitResults: any;
  onBackToReceipt: () => void;
}

const SplitEmailsStep: React.FC<SplitEmailsStepProps> = ({
  splitResults,
  onBackToReceipt
}) => {
  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      background: '#667eea',
      padding: '20px',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '30px',
        margin: '0 auto',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        maxWidth: '400px',
        width: '100%',
        animation: 'slideUp 0.6s ease-out'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: '#10b981',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 30px',
            animation: 'bounce 0.8s ease-out 0.3s both',
            position: 'relative'
          }}>
            <span style={{ fontSize: '36px', color: 'white' }}>📧</span>
          </div>
          <h1 style={{ fontSize: '24px', color: '#333', marginBottom: '10px' }}>
            Emaily odoslané
          </h1>
          <p style={{ color: '#666', fontSize: '16px', marginBottom: '10px' }}>
            týmto účastníkom:
          </p>
          {splitResults?.recipients && splitResults.recipients.length > 0 && (
            <ul style={{
              listStyle: 'none',
              padding: 0,
              textAlign: 'left',
              maxWidth: '300px',
              margin: '10px auto 20px auto'
            }}>
              {splitResults.recipients.map((recipient: any, idx: number) => (
                <li key={idx} style={{
                  color: '#667eea',
                  fontSize: '14px',
                  padding: '5px 0',
                  borderBottom: idx < splitResults.recipients.length - 1 ? '1px solid #e5e7eb' : 'none'
                }}>
                  ✉️ {recipient.name} ({recipient.email})
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Action Buttons */}
        <button
          onClick={onBackToReceipt}
          style={{
            width: '100%',
            padding: '15px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '18px',
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: '100px',
            textDecoration: 'none',
            display: 'inline-block',
            textAlign: 'center',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#5a67d8';
            e.currentTarget.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#667eea';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          ← Späť na bloček
        </button>
      </div>

      <style>
        {`
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes bounce {
            0% { transform: scale(0); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
};

export default SplitEmailsStep;
